/**
 * @file BinsOnboardingCard.tsx
 * @description Карточка «Как работают ячейки» (phase19.23, A4).
 *
 * Замечание пользователя при приёмке phase19.14: «не нашёл, как присваиваются
 * ячейки и как с ними работать». Три шага объясняют модель адресного хранения
 * прямо на экране; карточка закрывается и больше не возвращается
 * (`localStorage`, по магазину не различаем — подсказка общая).
 */

import { Lightbulb, X } from "lucide-react";
import { useState } from "react";

/** Ключ localStorage: подсказку закрыли — не показываем снова. */
const STORAGE_KEY = "chaiberi.wms.bins.onboarding.dismissed";

/** Шаги — данными: правка текста не трогает разметку. */
const STEPS = [
  {
    title: "1. Заведите адреса",
    text: "«Новая ячейка» или «Сгенерировать стеллаж» — адрес вида A-02-03 для полки и места.",
  },
  {
    title: "2. Положите товар",
    text: "«Положить товар» на карточке ячейки: выбираете фасовку с остатком и партию. Одна партия лежит в одной ячейке.",
  },
  {
    title: "3. Сборка идёт по адресам",
    text: "Кладовщик видит адрес в задании и обходит склад по порядку ячеек, а не ищет товар глазами.",
  },
];

export function BinsOnboardingCard() {
  const [hidden, setHidden] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "1",
  );
  if (hidden) return null;

  function dismiss() {
    localStorage.setItem(STORAGE_KEY, "1");
    setHidden(true);
  }

  return (
    <section className="relative rounded-xl border border-primary/30 bg-primary/5 p-4">
      <button
        type="button"
        onClick={dismiss}
        aria-label="Скрыть подсказку о ячейках"
        className="absolute right-2 top-2 inline-flex size-12 items-center justify-center rounded-full text-on-surface-variant hover:bg-surface-low"
      >
        <X className="size-5" />
      </button>
      <div className="flex items-center gap-2 pr-12 text-sm font-medium">
        <Lightbulb className="size-4 text-primary" aria-hidden />
        Как работают ячейки
      </div>
      <ul className="mt-2 grid grid-cols-1 gap-3 md:grid-cols-3">
        {STEPS.map((step) => (
          <li key={step.title} className="text-sm">
            <div className="font-medium">{step.title}</div>
            <p className="text-on-surface-variant">{step.text}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
